export class Role {
  uuid: string;
  name: string;
  permissions: string[];
}
